import { gql } from '@apollo/client';

export const TOGGLE_POST_MUTATION = gql`
  mutation TogglePost($id: Int!) {
    togglePost(id: $id) {
      id
    }
  }
`;